<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-elastic-dots" [fullScreen]="true"><p
  style="color: white"> Caricamento... </p></ngx-spinner>
<main role="main">

  <!--  <app-nav></app-nav>-->

  <!--  <section>-->
  <!--    <div class="container">-->
  <!--      <div class="progress mb-3">-->
  <!--        <div class="progress-bar progress-bar-striped bg-info" role="progressbar" style="width: 50%" aria-valuenow="50"-->
  <!--             aria-valuemin="0" aria-valuemax="100"></div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </section>-->
  <section class="height-custom-section">
    <ng-content></ng-content>
  </section>

</main>
